// extracted by mini-css-extract-plugin
export var grid = "mobile-language-selector-module--grid--1b154";
export var gridWithRowGap = "mobile-language-selector-module--grid--with-row-gap--b3124";
export var maxWidthContainer = "mobile-language-selector-module--max-width-container--250c8";
export var mobileLanguageSelector__item = "mobile-language-selector-module--mobile-language-selector__item--71dd8";
export var mobileLanguageSelector__itemFocus = "mobile-language-selector-module--mobile-language-selector__item--focus--d3ab3";
export var mobileLanguageSelector__itemSelected = "mobile-language-selector-module--mobile-language-selector__item--selected--ef351";
export var mt0 = "mobile-language-selector-module--mt-0--b96e7";
export var mt1 = "mobile-language-selector-module--mt-1--7b741";
export var mt2 = "mobile-language-selector-module--mt-2--01b05";
export var mt3 = "mobile-language-selector-module--mt-3--b0b43";
export var mt4 = "mobile-language-selector-module--mt-4--6c2e8";
export var mt5 = "mobile-language-selector-module--mt-5--29d95";
export var mt6 = "mobile-language-selector-module--mt-6--657c8";
export var removeVisuallyHidden = "mobile-language-selector-module--remove-visually-hidden--3c217";
export var visuallyHidden = "mobile-language-selector-module--visually-hidden--90c66";
export var widgetBase = "mobile-language-selector-module--widget-base--33480";